import { CommunicatorService } from 'ui-ng-component-communicator';
import { ISectionAvailabilityDatasource } from '../../sections/datasources/section_availability_datasource';
import { ScheduledSectionsQuery } from '../queries/scheduled_sections_query';
import { IWaitlistStatusDatasource } from '../datasources/waitlist_status_datasource';
import { RegisterSectionsQuery } from '../queries/register_sections_query';
import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { SchedulerModel } from '../models/scheduler_model';
import * as _4 from 'lodash4';
import { TermScheduleFlags } from '../services/term_schedule_flags';
import { CalendarTimesModel } from '../../calendar/models/calendar_times_model';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import { UpdateCalendarSectionTimesCommand } from '../../calendar/commands/update_calendar_section_times_command';
import { ScheduledSectionStatus } from '../types/scheduled_section_status_enum';

export type GetPusherSeatsAvailableCommand = (sectionIds?: Array<ISection['id']>) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'getPusherSeatsAvailableCommand',
    (
      $http: ng.IHttpService,
      $timeout: ng.ITimeoutService,
      ngSectionsDatasource: ISectionsDatasource,
      ngScheduledSectionsQuery: ScheduledSectionsQuery,
      defineCommandORM: IDefineCommand,
      QueryMediator: IQueryMediator,
      ngSchedulerModel: SchedulerModel,
      ngWaitlistStatusDatasource: IWaitlistStatusDatasource,
      ngSectionAvailabilityDatasource: ISectionAvailabilityDatasource,
      pusherService: any,
      ngTermScheduleFlags: TermScheduleFlags,
      $stateParams: ng.ui.IStateParamsService,
      ngCalendarTimesModel: CalendarTimesModel,
      ngComponentCommunicatorService: CommunicatorService,
      updateCalendarSectionTimesCommand: UpdateCalendarSectionTimesCommand,
      log: any
    ): ICommand => {
      return defineCommandORM('getPusherSeatsAvailableCommand', (deferred, sectionIds?: number[]) => {
        if (!ngTermScheduleFlags.isOneClickRegistrationEnabled()) {
          return deferred.resolve();
        }
        const termId = parseInt($stateParams.termId, 10);
        let seatsNeededSectionIds;
        if (sectionIds) {
          seatsNeededSectionIds = sectionIds;
        } else {
          const seatsNeededSections = [
            ...ngScheduledSectionsQuery.result.scheduledSections,
            ...ngScheduledSectionsQuery.result.scheduledMultiSections,
            ...ngScheduledSectionsQuery.result.multiSectionsWithTiedUnscheduledSectionTypes,
            ...ngScheduledSectionsQuery.result.waitlistedSections
          ];
          seatsNeededSectionIds = _4.map(seatsNeededSections, 'id');
        }
        if (_4.isEmpty(seatsNeededSectionIds)) {
          deferred.resolve();
        }
        const pusher_callback_function = (data: {
          [key: number]: {
            avail_seats: number;
            is_seat_available: boolean;
          };
        }) => {
          // Typescript is giving trouble using _4.each();
          for (const key in data) {
            const sectionId = parseInt(key, 10);
            const section_waitlist_availability = ngWaitlistStatusDatasource.get(sectionId);
            const section_availability = ngSectionAvailabilityDatasource.get(sectionId);
            if (section_waitlist_availability) {
              section_waitlist_availability.avail_seats = data[key].avail_seats;
              section_waitlist_availability.is_seat_available = data[key].is_seat_available;
              ngWaitlistStatusDatasource.put(section_waitlist_availability);
            } else {
              ngWaitlistStatusDatasource.put({
                avail_seats: data[key].avail_seats,
                id: sectionId,
                is_waitlist_allowed: false,
                is_waitlist_full: undefined,
                is_seat_available: true,
                is_auto_waitlist: _4.get(data[key], 'is_auto_waitlist', false),
                last_refresh_ts: _4.get(data[key], 'last_refresh_ts', ''),
                linked_section_coreqs_satisfied: _4.get(data[key], 'linked_section_coreqs_satisfied', true),
                has_linked_section_coreqs: _4.get(data[key], 'has_linked_section_coreqs', false)
              });
            }
            if (section_availability) {
              section_availability.avail_seats = data[key].avail_seats;
              section_availability.is_seat_available = data[key].is_seat_available;
              ngSectionAvailabilityDatasource.put(section_availability);
            }
          }
          updateCalendarSectionTimesCommand().finally(() => {
            QueryMediator.runQueries(
              ngSectionsDatasource,
              ngWaitlistStatusDatasource,
              ngSectionAvailabilityDatasource,
              ngCalendarTimesModel
            );
            deferred.resolve();
            ngComponentCommunicatorService.publish('SEATS_INFO_UPDATED');
          });
        };
        pusherService.bindToPusherEvent(
          ngSchedulerModel.read().channel_name,
          'seats_available',
          pusher_callback_function
        );
        $http
          .post('reg/seatavailability/', {
            term: termId,
            sections: seatsNeededSectionIds
          })
          .catch(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            log.issue('failed to update available seats');
            deferred.reject(data);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/commands/get_pusher_seats_available_command.ts